module.exports = __webpack_public_path__ + "img/receivebox1.2f1e08d0.png";